import type { NpvrStatus } from '@norlys-a-s/norlys-play-kmm';

import { NpvrRecordingTimeSpan, NpvrStatusInfo } from '@smart-tv/typings/npvr';

import { kmm } from './kmm';

const mapRecordingTimeSpan = (span: {
  inHours: number;
  inMinutes: number;
}): NpvrRecordingTimeSpan => ({
  inHours: span.inHours,
  inMinutes: span.inMinutes
});

const mapNumberOfRecordings = (numberOfRecordings: NpvrStatus.NumberOfRecordings) => ({
  scheduled: numberOfRecordings.scheduled,
  total: numberOfRecordings.total
});

const mapRecordingTime = (recordingTime: NpvrStatus.RecordingTime) => ({
  scheduled: mapRecordingTimeSpan(recordingTime.scheduled),
  total: mapRecordingTimeSpan(recordingTime.total),
  used: mapRecordingTimeSpan(recordingTime.used)
});

const mapNpvrStatus = (status: NpvrStatus): NpvrStatusInfo => ({
  numberOfRecordings: mapNumberOfRecordings(status.numberOfRecordings),
  recordingTime: mapRecordingTime(status.recordingTime),
  remainingUnusedSeconds: status.remainingUnusedSeconds,
  recordedSpaceRatio: status.recordedSpaceRatio,
  scheduledSpaceRatio: status.scheduledSpaceRatio,
  totalUsedSpaceRatio: status.totalUsedSpaceRatio,
  usedSpaceHoursDisplayName: status.usedSpaceHoursDisplayName,
  recordedSpaceDisplayName: status.recordedSpaceDisplayName,
  scheduledSpaceDisplayName: status.scheduledSpaceDisplayName,
  freeSpaceDisplayName: status.freeSpaceDisplayName,
  spaceWarningDisplayMessage: status.spaceWarningDisplayMessage ?? null
});

export async function getNpvrStatus(): Promise<NpvrStatusInfo> {
  const status = await kmm((repo) => repo.getNpvrStatus(), false);

  return mapNpvrStatus(status);
}

export default getNpvrStatus;
